<!--
    Styles
-->

<style>


    /* main */

    .ui-range {
        background: var(--cl-white);
    }


    /* form */

    .ui-range .form {
        padding: 10px;
        border-bottom: 1px solid var(--cl-gray);
    }
    .ui-range .form span,
    .ui-range .form input {
        margin-left: 6px;
    }
    .ui-range .form input {
        min-width: 0;
        height: 30px;
    }
    .ui-range .form input:first-child {
        margin-left: 0;
    }


    /* options */

    .ui-range .option.min:after {
        content: ' ~';
    }
    .ui-range .option.max:before {
        content: '~ ';
    }


    /* cancel */

    .ui-range .cancel {
        border-top: 1px solid var(--cl-gray);
    }
    .ui-range .cancel.disabled {
        pointer-events: none;
        color: var(--cl-gray);
    }

</style>



<!--
    Template
-->

<template>
    <div class="ui-range dropdown">


        <!-- form -->

        <div class="form u-row">

            <input
                class="input u-flex"
                type="number"
                ref="min"
                :value="min"
                @focus="focus('min')"
                @input="input($event, 'min')"
            >

            <span>~</span>

            <input
                class="input u-flex"
                type="number"
                ref="max"
                :value="max"
                @focus="focus('max')"
                @input="input($event, 'max')"
            >

            <span>{{ label }}</span>

        </div>


        <!-- options -->

        <a class="option w5"
           :class="pick"
           v-for="(option, index) in options"
           v-show="filter(option)"
           :key="index"
           @click="set(option)"
        >{{ option }}</a>


        <!-- cancel -->

        <a class="option cancel w5 cl-blue"
           :class="{disabled: !min && !max}"
           @click="clear()"
        >クリア</a>


    </div>
</template>



<!--
    Scripts
-->

<script>


    const exists = param => {
        return param !== null && param !== undefined;
    };


    export default {

        props: [
            'min',
            'max',
            'label',
            'options'
        ],

        data () {
            return {
                pick: 'min'
            }
        },

        methods: {

            update (min, max) {
                this.$emit('update', {min, max});
            },

            focus (key) {
                this.pick = key;
            },

            input (event, key) {
                let min = this.min;
                let max = this.max;
                let value = event.target.value;
                if (value < 0) value = event.target.value = 0;
                if (key === 'min') min = value;
                if (key === 'max') max = value;
                if (key === 'min' && exists(max)) max = Math.max(min, max);
                if (key === 'max' && exists(min)) min = Math.min(min, max);
                this.update(min, max);
            },

            set (value) {
                if (this.pick === 'min') this.setMin(value);
                else this.setMax(value);
            },

            setMin (value) {
                this.update(value, this.max);
                this.pick = 'max';
                if (exists(this.max)) this.$parent.hide();
            },

            setMax (value) {
                this.update(this.min, value);
                this.$parent.hide();
            },

            filter (option) {
                if (this.pick === 'max') return option > (this.min || 0);
                else return option < (this.max || Number.MAX_VALUE);
            },

            clear () {
                this.pick = 'min';
                this.update();
                this.$parent.hide();
            }

        },

        watch: {

            '$parent.active' (value) {
                if (!value) return;
                this.$refs[this.pick].focus();
            },

            pick (value) {
                this.$refs[value].focus();
            }

        }

    }

</script>

